import actionTypes from 'redux/actionTypes';
import { deepClone, isObjEmpty } from 'helper/helper';
import { PARENT_CUST_ATTR } from 'constants/constant';

export function setSelectedList(data) {
	return {
		type: actionTypes.SET_SELECTED_LIST,
		payload: data
	};
}

export function setFilterList(data) {
	return {
		type: actionTypes.SET_FILTER_LIST,
		payload: data
	};
}

export function clearUnSelectedItemsFilters(list) {
	return {
		type: actionTypes.CLEAR_UNSELECTED_ITEMS_FILTERS,
		payload: list
	};
}

export function setPrevSelectedList(data) {
	return {
		type: actionTypes.SET_PREV_SELECTED_LIST,
		payload: data
	};
}

export function setPrevFilterList(data) {
	return {
		type: actionTypes.SET_PREV_FILTER_LIST,
		payload: data
	};
}

export function draftPrevSelectedList(data) {
	return {
		type: actionTypes.DRAFT_PREV_SELECTED_LIST,
		payload: data
	};
}

export function draftPrevFilterList(data) {
	return {
		type: actionTypes.DRAFT_PREV_FILTER_LIST,
		payload: data
	};
}

export function draftPrevPivotOption(data) {
	return {
		type: actionTypes.DRAFT_PREV_PIVOT_OPTION,
		payload: data
	};
}

export function loadPreviewPage(data) {
	return {
		type: actionTypes.LOAD_PREVIEW_PAGE,
		payload: data
	};
}

export function loadPreviewData(data) {
	return {
		type: actionTypes.LOAD_PREVIEW_DATA,
		payload: data
	};
}

export function getPreview(data) {
	return {
		type: actionTypes.GET_PREVIEW,
		payload: data
	};
}

export function getPreviewSuccess(data) {
	return {
		type: actionTypes.GET_PREVIEW_SUCCESS,
		payload: data
	};
}

export function getPreviewFailure(data) {
	return {
		type: actionTypes.GET_PREVIEW_FAILURE,
		payload: data
	};
}

export function clearPreview(data) {
	return {
		type: actionTypes.CLEAR_PREVIEW,
		payload: data
	};
}

export function clearPrevSelection() {
	return {
		type: actionTypes.CLEAR_PREV_SELECTION,
		payload: []
	};
}

export function addPreviewColumn(data, key) {
	let _data = deepClone(data);
	if (_data.jsonResponse === undefined || _data.jsonResponse.length === 0) {
		_data = { jsonResponse: [] };
	} else {
		const newAttribute = {};
		_data = {
			jsonResponse: data.jsonResponse.map((item) => {
				newAttribute[`table.${key}`] = null;
				return { ...item, ...newAttribute };
			})
		};
	}
	return {
		type: actionTypes.ADD_PREVIEW_COLUMN,
		payload: _data
	};
}

export function removePreviewColumn(data, colName, parent = '', tblName = '') {
	let _data = deepClone(data);
	if (_data.jsonResponse === undefined || _data.jsonResponse.length === 0) {
		_data = { jsonResponse: [] };
	} else {
		_data = {
			jsonResponse: _data.jsonResponse.filter((item) => {
				for (const key in item) {
					const [tbl, col] = key.split('.');
					if (parent === PARENT_CUST_ATTR) {
						if (tbl === tblName) {
							delete item[`${tbl}.${col}`];
						}
					} else {
						/** it is important to compare parent here also otherwise col === colName will delete all the elements. */
						if (parent !== PARENT_CUST_ATTR) {
							if (col === colName) {
								delete item[`${tbl}.${col}`];
							}
						}
					}
				}

				if (!isObjEmpty(item)) {
					return item;
				}
			})
		};
	}

	return {
		type: actionTypes.REMOVE_PREVIEW_COLUMN,
		payload: _data
	};
}

export function getRowCount(data) {
	return {
		type: actionTypes.GET_ROW_COUNT,
		payload: data
	};
}

export function getRowCountSuccess(data) {
	return {
		type: actionTypes.GET_ROW_COUNT_SUCCESS,
		payload: data
	};
}

export function getRowCountFailure(data) {
	return {
		type: actionTypes.GET_ROW_COUNT_FAILURE,
		payload: data
	};
}

export function clearPreviewLoaded() {
	return {
		type: actionTypes.CLEAR_PREVIEWED_LOADED
	};
}

export function setMenu(data) {
	return {
		type: actionTypes.SET_MENU,
		payload: data
	};
}

export function setIsMandateCheck(data) {
	return {
		type: actionTypes.SET_IS_MANDATE_CHECK,
		payload: data
	};
}

export function setRequiredCheck(data) {
	return {
		type: actionTypes.SET_REQUIRED_CHECK,
		payload: data
	};
}

export function setLinkItemActivity(data) {
	return {
		type: actionTypes.SET_LINK_ITEMS_ACTIVITY,
		payload: data
	};
}

export function setHierarchy(data) {
	return {
		type: actionTypes.SET_HIERARCHY,
		payload: data
	};
}

export function saveDraft(data) {
	return {
		type: actionTypes.SAVE_DRAFT,
		payload: data
	};
}

export function saveDraftSuccess(data) {
	return {
		type: actionTypes.SAVE_DRAFT_SUCCESS,
		payload: data
	};
}

export function saveDraftFailure(data) {
	return {
		type: actionTypes.SAVE_DRAFT_FAILURE,
		payload: data
	};
}

export function resetDraft(data) {
	return {
		type: actionTypes.RESET_DRAFT,
		payload: data
	};
}

export function resetSavedDraftStatus() {
	return {
		type: actionTypes.RESET_SAVED_DRAFT_STATUS
	};
}

export function resetRowCountObject() {
	return {
		type: actionTypes.RESET_ROWCOUNT_OBJ
	};
}

export function saveItemShareStatus(_isEnabled) {
	return {
		type: actionTypes.ITEM_SHARED_STATUS,
		payload: _isEnabled
	};
}

export function saveItemShareMandatorySelection(list) {
	return {
		type: actionTypes.ITEM_SHARE_MANDATORY_SELECTION,
		payload: list
	};
}

export function getPinnedAttribute(payload) {
	return {
		type: actionTypes.GET_PINNED_ATTRIBUTE,
		payload
	};
}

export function getPinnedAttributeSuccess(payload) {
	return {
		type: actionTypes.GET_PINNED_ATTRIBUTE_SUCCESS,
		payload
	};
}

export function getPinnedAttributeFailure(payload) {
	return {
		type: actionTypes.GET_PINNED_ATTRIBUTE_FAILURE,
		payload
	};
}

export function setPinnedAttribute(payload) {
	return {
		type: actionTypes.SET_PINNED_ATTRIBUTE,
		payload
	};
}

export function savePinnedAttribute(payload) {
	return {
		type: actionTypes.SAVE_PINNED_ATTRIBUTE,
		payload
	};
}

export function savePinnedAttributeFailure(payload) {
	return {
		type: actionTypes.SAVE_PINNED_ATTRIBUTE_FAILURE,
		payload
	};
}

export function setPinnedAttributeSnackbar(payload) {
	return {
		type: actionTypes.SET_PINNED_ATTRIBUTE_SNACKBAR,
		payload
	};
}

export function setIsMTSFilterCollapsed(payload) {
	return {
		type: actionTypes.SET_IS_MTS_FILTER_COLLAPSED,
		payload
	};
}

export function setPivotOptions(payload) {
	return {
		type: actionTypes.SET_PIVOT_OPTS,
		payload
	};
}

export const resetPivotOptions = () => {
	return setPivotOptions({
		showPopup: false,
		pivotColumn: null,
		isMultiWeek: false,
		isTimeAcross: false
	});
};

export const getVisualHierarchyData = (payload) => {
	return {
		type: actionTypes.GET_VISUAL_HIERARCHY,
		payload
	};
};

export const getVisualHierarchyDataSuccess = (payload) => {
	return {
		type: actionTypes.GET_VISUAL_HIERARCHY_SUCCESS,
		payload
	};
};

export const getVisualHierarchyDataFailure = (payload) => {
	return {
		type: actionTypes.GET_VISUAL_HIERARCHY_FAILURE,
		payload
	};
};
